// Icons whose CSS class is assembled at runtime, so bin/fa-icons cannot see them by
// scanning markup. Each group records the call site that needs it — when that call site
// changes or goes away, update this list. A name that doesn't exist fails the Vite build
// rather than rendering as blank space.
//
// New interpolated icon class? .erb_linters/font_awesome_icon_linter.rb will point you here.

import {
  faCcAmex,
  faCcDiscover,
  faCcMastercard,
  faCcPaypal,
  faCcVisa,
  faFacebook,
  faGoogle,
} from '@fortawesome/free-brands-svg-icons';
import {
  faArrowUpRightFromSquare as fadArrowUpRightFromSquare,
  faCalendarDays as fadCalendarDays,
  faChartBar as fadChartBar,
  faChartLine as fadChartLine,
  faCircleArrowDown as fadCircleArrowDown,
  faCircleArrowUp as fadCircleArrowUp,
  faFileAudio as fadFileAudio,
  faFileBinary as fadFileBinary,
  faFileDoc as fadFileDoc,
  faFileImage as fadFileImage,
  faFilePdf as fadFilePdf,
  faFilePowerpoint as fadFilePowerpoint,
  faFileSpreadsheet as fadFileSpreadsheet,
  faFileText as fadFileText,
  faFileVideo as fadFileVideo,
  faFileZip as fadFileZip,
  faFolderOpen as fadFolderOpen,
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faArrowDownShortWide as farArrowDownShortWide,
  faArrowDownWideShort as farArrowDownWideShort,
  faBars as farBars,
  faComment as farComment,
  faStar as farStar,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArchive,
  faArrowTrendDown,
  faArrowTrendUp,
  faCaretDown,
  faCaretUp,
  faCheck,
  faChevronDown,
  faChevronUp,
  faComment,
  faPause,
} from '@fortawesome/pro-solid-svg-icons';

// app/views/admin/ai/operational_insights/_conversation_item.html.erb
//   fas fa-<%= archived ? 'archive' : 'comment' %>
const conversationItem = [faArchive, faComment];

// app/views/admin/one_password/users/{index,show}.html.erb
//   fas fa-<%= user.active? ? 'check' : 'pause' %>
const onePasswordUserStatus = [faCheck, faPause];

// app/components/admin/flipper_audits/table_component.rb
//   fa fa-caret-#{@direction == 'desc' ? 'down' : 'up'}
const sortCarets = [faCaretUp, faCaretDown];

// app/views/business_pulse/metrics/_row.html.erb
//   fa-solid fa-arrow-trend-<%= trend >= 0 ? 'up' : 'down' %>
const businessPulseTrend = [faArrowTrendUp, faArrowTrendDown];

// app/frontend/controllers/team_playbook/task_details_controller.js
//   classList.replace(`fa-chevron-${from}`, `fa-chevron-${to}`)
const taskDetailsCaret = [faChevronUp, faChevronDown];

// app/frontend/controllers/hyper/menu_toggle_controller.js
//   classList.add('fa-regular') then classList.toggle('fa-bars' | 'fa-ellipsis-vertical').
//   The style lands on a different line than the icon, so bin/fa-icons scopes each icon
//   alone and resolves it to solid; only the regular ellipsis-vertical survives, via the
//   static scan of layouts/hyper/topbar/_menu_toggle_button.html.erb.
const menuToggle = [farBars];

// app/views/sales/opportunities/_deal_team_chip.html.erb
//   fa-<%= lead ? 'solid' : 'regular' %> fa-star  (solid comes from the static scan)
const dealTeamChip = [farStar];

// app/components/tasks/beta/comments_badge_component.html.erb
//   component :icon, icon: 'comment', variant: icon_variant  (solid comes from the static scan)
const taskCommentsBadge = [farComment];

// app/views/sales/notes/_content.html.erb
//   fa-regular fa-arrow-down-<%= direction == 'asc' ? 'short-wide' : 'wide-short' %>
const noteSortDirection = [farArrowDownShortWide, farArrowDownWideShort];

// app/views/financial_metrics/trends/_trend.html.erb
//   fa-duotone fa-chart-<%= type %>  for type in %w(bar line)
const trendChartType = [fadChartBar, fadChartLine];

// app/components/financial_metrics/scorecard_component.rb
//   fa-duotone fa-circle-arrow-#{value >= 1 ? 'up' : 'down'}
const scorecardChange = [fadCircleArrowUp, fadCircleArrowDown];

// app/views/storage/_row.html.erb
//   fa fa-2x fa-duotone fa-<%= decorated_item.item_type %>
// app/frontend/controllers/storage_dropzone_controller.js
//   classList.add(`fa-${extensionIcons[extension]}`) on the upload modal's queued-file rows
// Values come from Storage::ItemDecorator#item_type and EXTENSION_ICONS, which the upload
// modal passes to that controller as a data value.
const storageItemType = [
  fadArrowUpRightFromSquare,
  fadCalendarDays,
  fadFileAudio,
  fadFileBinary,
  fadFileDoc,
  fadFileImage,
  fadFilePdf,
  fadFilePowerpoint,
  fadFileSpreadsheet,
  fadFileText,
  fadFileVideo,
  fadFileZip,
  fadFolderOpen,
];

// app/views/accounting_services/show.html.erb
//   fa-brands fa-<%= review[:source].downcase.gsub(' ', '-') %>
const reviewSources = [faGoogle, faFacebook];

// app/decorators/chargebee_payment_source_decorator.rb
//   fab fa-cc-#{object.brand}, plus the literal 'fab fa-cc-amex' branch
const cardBrands = [faCcVisa, faCcMastercard, faCcDiscover, faCcPaypal, faCcAmex];

export const dynamicIcons = [
  ...businessPulseTrend,
  ...cardBrands,
  ...conversationItem,
  ...dealTeamChip,
  ...menuToggle,
  ...noteSortDirection,
  ...onePasswordUserStatus,
  ...reviewSources,
  ...scorecardChange,
  ...sortCarets,
  ...storageItemType,
  ...taskCommentsBadge,
  ...taskDetailsCaret,
  ...trendChartType,
];
